export const EXCLUDED_COUNTRIES = ['IN', 'RU', 'C2'];

export const APPLE_PAY_BILLING_BUTTON_METRICS = {
  CLICK_COMPLETE:
    'GUEST_SIGNUP.BILLING_PAY_WITH_OTHER_FUNDING_SOURCE_CLICKED.COMPLETE',
  CLICK_ERROR:
    'GUEST_SIGNUP.BILLING_PAY_WITH_OTHER_FUNDING_SOURCE_CLICKED.ERROR',
} as const;
